import { pxToRem } from './helpers.mjs';

function colorResolver(color) {
  if (typeof color === "string") return color;
  return color;
}
function fontFamilyResolver(fontFamily) {
  const fontFamilyValues = {
    text: "var(--serif-font-family)"
  };
  if (typeof fontFamily === "string" && fontFamily in fontFamilyValues) {
    return fontFamilyValues[fontFamily];
  }
  return fontFamily;
}
function fontSizeResolver(value) {
  if (typeof value === "number") {
    return pxToRem(value);
  }
  if (typeof value === "string") {
    if (value.endsWith("px")) {
      return pxToRem(value);
    } else if (value.endsWith("rem")) {
      return value;
    }
  }
  return value;
}
function identityResolver(value) {
  return value;
}
function sizeResolver(value) {
  if (typeof value === "number") {
    return `${value}px`;
  }
  return value;
}
function spacingResolver(value) {
  if (typeof value === "number" || !isNaN(Number(value))) {
    return `${value}px`;
  }
  if (typeof value === "string") {
    return `${value}`;
  }
  return value;
}
function lineHeightResolver(value) {
  if (typeof value === "number") {
    return `${value}px`;
  }
  if (typeof value === "string") {
    return `${value}`;
  }
  return value;
}
const resolvers = {
  identity: identityResolver,
  size: sizeResolver,
  spacing: spacingResolver,
  color: colorResolver,
  textColor: colorResolver,
  fontSize: fontSizeResolver,
  lineHeight: lineHeightResolver,
  fontFamily: fontFamilyResolver
};

export { resolvers, sizeResolver, spacingResolver };
